import { type ReactNode } from 'react'

import { SIDEBAR_WIDTH_PX, Sidebar } from './sidebar'
import { Topbar } from './topbar'

/**
 * App shell for every authenticated admin route.
 *
 * Layout:
 *   ┌──────────┬───────────────────────────────────────┐
 *   │          │             Topbar (56px)             │
 *   │ Sidebar  ├───────────────────────────────────────┤
 *   │ (240px)  │                                       │
 *   │          │              content                  │
 *   │          │                                       │
 *   └──────────┴───────────────────────────────────────┘
 *
 * The sidebar is `fixed` and the content reserves a left margin
 * of the sidebar's expanded width. We deliberately don't reflow
 * when the sidebar collapses — the saved 176px would jump the
 * whole content area, which is jarring on dense pages. If users
 * complain we'll lift the collapsed flag to a context and animate
 * the margin.
 */
interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-surface-muted">
      <Sidebar />
      <div
        className="flex flex-col min-h-screen"
        style={{ marginLeft: SIDEBAR_WIDTH_PX }}
      >
        <Topbar />
        <main className="flex-1 p-6 max-w-screen-2xl w-full">{children}</main>
      </div>
    </div>
  )
}
